import * as React from 'react';
import { FIELD_TYPE } from 'app/infrastructure/simple-form';
import { FilterCommonProps } from '../types';
import { customFilterFieldPostfix } from 'app/components/filters/filters-panel/constants';

export class FilterPredefinedDate extends React.Component<FilterCommonProps, {}> {

  public render() {
    const { simpleFormComponent: SimpleForm, filterDomain } = this.props;

    return <SimpleForm
      name={filterDomain.id + customFilterFieldPostfix.predefDate}
      type={FIELD_TYPE.DATE_TIME}
      initialValue={!!filterDomain.initialValue ? filterDomain.initialValue : undefined}
      placeholder={this.props.translation && this.props.translation.filters_date_placeholder}
    />;
  }
}
